export type ButtonDropdownProps = {
  id: string;
  title: string;
  icon?: string;
  desc?: string;
  href: string;
  type?: 'icon' | 'desc' | 'normal';
  items?: ButtonDropdownProps[];
  childrenUrls?: string[];
};

export type PopOverProps = {
  id: string;
  title: string;
  href?: string;
  childrenUrls?: string[];
  items?: ButtonDropdownProps[];
};

export const headerDataKinhDoanh: PopOverProps[] = [
  {
    id: 'p2',
    title: 'businessIdeas',
    href: '/y-tuong-kinh-doanh',
  },
  {
    id: 'p1',
    title: 'businessExperience',
    href: '/kinh-nghiem-kinh-doanh',
    childrenUrls: [
      '/kinh-nghiem-kinh-doanh/kinh-nghiem-mo-cua-hang',
      '/kinh-nghiem-kinh-doanh/ban-hang-online',
      '/kinh-nghiem-kinh-doanh/kinh-doanh-tren-facebook',
      '/kinh-nghiem-kinh-doanh/kinh-doanh-tren-shopee',
      '/kinh-nghiem-kinh-doanh/kinh-doanh-tren-tiktok-shop',
      '/kinh-nghiem-kinh-doanh/kinh-doanh-tren-lazada',
      '/kinh-nghiem-kinh-doanh/kien-thuc-marketing',
    ],
    items: [
      {
        id: 'p1c1',
        title: 'Kinh nghiệm mở cửa hàng',
        type: 'normal',
        icon: '/static/icons/AhaShip.svg',
        href: '/kinh-nghiem-kinh-doanh/kinh-nghiem-mo-cua-hang',
      },
      {
        id: 'p1c2',
        title: 'Bán hàng online',
        type: 'normal',
        icon: '/static/icons/AhaTruck.svg',
        href: '/kinh-nghiem-kinh-doanh/ban-hang-online',
      },
      {
        id: 'p1c3',
        title: 'Kinh doanh trên Facebook',
        icon: '/static/icons/AhaSupply.svg',
        type: 'normal',
        href: '/kinh-nghiem-kinh-doanh/kinh-doanh-tren-facebook',
      },
      {
        id: 'p1c4',
        title: 'Kinh doanh trên Shopee',
        type: 'normal',
        icon: '/static/icons/AhaShip.svg',
        href: '/kinh-nghiem-kinh-doanh/kinh-doanh-tren-shopee',
      },
      {
        id: 'p1c5',
        title: 'Kinh doanh trên TikTok Shop',
        type: 'normal',
        icon: '/static/icons/AhaTruck.svg',
        href: '/kinh-nghiem-kinh-doanh/kinh-doanh-tren-tiktok-shop',
      },
      {
        id: 'p1c6',
        title: 'Kinh doanh trên Lazada',
        icon: '/static/icons/AhaSupply.svg',
        type: 'normal',
        href: '/kinh-nghiem-kinh-doanh/kinh-doanh-tren-lazada',
      },
      {
        id: 'p1c7',
        title: 'Kiến thức Marketing',
        icon: '/static/icons/AhaSupply.svg',
        type: 'normal',
        href: '/kinh-nghiem-kinh-doanh/kien-thuc-marketing',
      },
    ],
  },
  {
    id: 'p3',
    title: 'goodsSource',
    href: '/nguon-hang',
    childrenUrls: [
      '/nguon-hang/cho-dau-moi',
      '/kinh-doanh/nguon-hang/cach-nhap-hang',
    ],
    items: [
      {
        id: 'p3c1',
        title: 'Chợ đầu mối',
        type: 'normal',
        href: '/nguon-hang/cho-dau-moi',
      },
      {
        id: 'p3c2',
        title: 'Cách nhập hàng',
        type: 'normal',
        href: '/nguon-hang/cach-nhap-hang',
      },
    ],
  },
  {
    id: 'p4',
    title: 'warehouse',
    href: '/kho-bai',
  },
];
